<template>
  <div class="container-lg mt-3">
    <h2 class="accordion-header" id="headingBeneficios">Datos de uso</h2>
    <div
      id="collapseBeneficios"
      class="accordion-collapse collapse show"
      aria-labelledby="headingBeneficios"
      data-bs-parent="#accordionExample"
    >
      <div class="accordion-body">
        <TablaEstadisticas
          :busqueda="busqueda"
          :lista="beneficios"
          :mostrarAcciones="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BuscarPor, OrdenarPor } from "../../data/enums";
import { Icons as IconConstants } from "../../constants";
import TablaEstadisticas from "./tablas/TablaEstadisticas.vue";

export default {
  components: {
    TablaEstadisticas,
  },
  computed: {
    Icons() {
      return IconConstants;
    },
  },
  data() {
    return {
      busqueda: {
        valor: this.Busqueda,
        buscarPor: BuscarPor.comercio,
        ordenarPor: OrdenarPor.relevancia,
      },
      beneficios: [],
      comentarios: [],
      comercios: [],
      token: "",
    };
  },
  methods: {
    acordionBeneficiosExpandido() {
      console.log("Mostrar beneficios");
    },
    acordionComentariosExpandido() {
      console.log("Mostrar comentarios");
    },
    acordionComerciosExpandido() {
      console.log("Mostrar comercios");
    },
    clickBuscar() {},
    /** Verdadero si la búsqueda cacheada es distinta a la actual */
    esDistinta(cacheada) {
      if (cacheada == null) return true;

      if (cacheada.valor != this.busqueda.valor) return true;

      if (cacheada.buscarPor != this.busqueda.buscarPor) return true;

      if (cacheada.ordenarPor != this.busqueda.ordenarPor) return true;

      return false;
    },
    filtroBuscarPorCambiado(valor) {
      if (valor == this.busqueda.buscarPor) return;

      // Reconstruir el objeto para que se detecten los cambios en los componentes que lo usan
      this.busqueda = {
        valor: this.busqueda.valor,
        buscarPor: valor,
        ordenarPor: this.busqueda.ordenarPor,
      };
    },
    filtroOrdenarPorCambiado(valor) {
      if (valor == this.busqueda.ordenarPor) return;

      // Reconstruir el objeto para que se detecten los cambios en los componentes que lo usan
      this.busqueda = {
        valor: this.busqueda.valor,
        buscarPor: this.busqueda.buscarPor,
        ordenarPor: valor,
      };
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
  },
};
</script>

<style scoped>
.card {
  margin-top: 2em;
}
</style>
